import {
  getBetterInsuranceCoverage,
  getDittoCoverageTexts,
  getExcludedCoverages,
  getIncludedCoverages,
} from "Components/TextContext/utils/dittoCoverageUtils";
import React, { useState } from "react";
import {
  AccordionButton,
  Description,
  LeftJustifiedCollapisbleContainer,
  LeftJustifiedInsuranceTermsLink,
  LeftJustifiedIpidLinks,
} from "../coverages.styles";

import { WrapLgMarginBottom } from "App/global-style";
import { ChildHealthAlert } from "Components/Features/CheckPrice/Products/LifeProducts/Child/ProductPrice/ChildHealth/ChildHealthAlert";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { useTexts } from "Components/TextContext";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";
import { buttonTrackId } from "Utils/analytics";
import { getBetterInsuranceLabel } from "../coverages.helpers";
import { DittoCoverageCardAccordion } from "./DittoCoverageCardAccordion";

interface Props {
  product: ProductBackendName;
  cardIsSelected?: boolean;
  coverage: InsuranceCoverage;
  showExcludedCoverages?: boolean;
  insuranceDisplayName?: string;
}

export const DittoCoverageCardDetails: React.FC<Props> = ({
  product,
  cardIsSelected,
  coverage,
  showExcludedCoverages,
  insuranceDisplayName,
}) => {
  const { getText } = useTexts();
  const [showDetails, toggleDetails] = useState(false);
  const coverageTexts = getDittoCoverageTexts(product);
  const includedInThisCoverage = getIncludedCoverages(coverage, coverageTexts);
  const betterCoverage = getBetterInsuranceCoverage(coverage);

  const betterCoverageSubheading =
    product === ProductBackendName.ANIMAL
      ? getText("coveragecard.subheaders.anadditionalcoveragecovers", {
          variables: {
            coverageCard_coverage: getBetterInsuranceLabel(coverage),
          },
        })
      : getText("coveragecard.subheaders.abettercoveragecovers", {
          variables: {
            coverageCard_coverage: getBetterInsuranceLabel(coverage),
          },
        });

  const excludedInThisCoverage = getExcludedCoverages(
    coverage,
    betterCoverage,
    coverageTexts,
  );

  const isWithExcludedCoverages =
    excludedInThisCoverage !== undefined &&
    showExcludedCoverages &&
    excludedInThisCoverage.length > 0 &&
    betterCoverage !== undefined;

  const buttonId = `coverage-card__show-details-button_${coverage}`;

  return (
    <>
      <AccordionButton
        id={buttonId}
        className="coverage-card__show-detils-button"
        variant="text"
        iconRight={showDetails ? "chevron-up" : "chevron-down"}
        data-trackid={buttonTrackId("see-coverages")}
        onClick={() => toggleDetails(!showDetails)}
      >
        <p>{getText("coveragecard.buttons.seecoverage")}</p>
      </AccordionButton>

      <LeftJustifiedCollapisbleContainer isOpen={showDetails}>
        <Description fw={700} size={"16px"}>
          {insuranceDisplayName
            ? `${insuranceDisplayName} ${getText(
                "coveragecard.subheaders.thiscoveragecovers",
              )}`
            : getText("coveragecard.subheaders.thiscoveragecovers")}
        </Description>
        <WrapLgMarginBottom>
          <DittoCoverageCardAccordion
            cardId={String(coverage)}
            coverages={includedInThisCoverage}
            cardIsSelected={cardIsSelected}
            includedCoverages
          />
        </WrapLgMarginBottom>
        {isWithExcludedCoverages && (
          <>
            <Description fw={700} size={"16px"}>
              {betterCoverageSubheading}
            </Description>
            <DittoCoverageCardAccordion
              cardId={String(coverage)}
              coverages={excludedInThisCoverage}
              cardIsSelected={cardIsSelected}
            />
          </>
        )}
        <ChildHealthAlert product={product} />
        <LeftJustifiedIpidLinks
          coverage={coverage}
          isOnColoredBackground={cardIsSelected}
        />
        <LeftJustifiedInsuranceTermsLink
          productBackendName={product}
          isOnColoredBackground={cardIsSelected}
        />
      </LeftJustifiedCollapisbleContainer>
    </>
  );
};
